/* eslint-disable ember/no-classic-components */
import Component, { setComponentTemplate } from "@ember/component";
import { fn } from "@ember/helper";
import { on } from "@ember/modifier";
import { computed } from "@ember/object";
import { guidFor } from "@ember/object/internals";
import { tagName } from "@ember-decorators/component";
import icon from "discourse/helpers/d-icon";
import { i18n } from "discourse-i18n";
import selectKitPropUtils from "select-kit/lib/select-kit-prop-utils";
import { precompileTemplate } from "@ember/template-compilation";
const SelectedChoice = dt7948.c(class SelectedChoice extends Component {
  item = null;
  selectKit = null;
  extraClass = null;
  id = null;
  init() {
    super.init(...arguments);
    this.set("id", guidFor(this));
  }
  get itemValue() {
    return this.getValue(this.item);
  }
  static {
    dt7948.n(this.prototype, "itemValue", [computed("item")]);
  }
  get itemName() {
    return this.getName(this.item);
  }
  static {
    dt7948.n(this.prototype, "itemName", [computed("item")]);
  }
  get mandatoryValuesArray() {
    return this.get("mandatoryValues")?.split("|") || [];
  }
  static {
    dt7948.n(this.prototype, "mandatoryValuesArray", [computed("item")]);
  }
  get readOnly() {
    if (typeof this.item === "string") {
      return this.mandatoryValuesArray.includes(this.item);
    }
    return this.mandatoryValuesArray.includes(this.item.id);
  }
  static {
    dt7948.n(this.prototype, "readOnly", [computed("item")]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    {{#if this.readOnly}}\n      <button class=\"btn btn-default disabled\" title={{i18n \"admin.site_settings.mandatory_group\"}}>{{this.itemName}}</button>\n    {{else}}\n      <button {{on \"click\" (fn this.selectKit.deselect this.item)}} aria-label={{i18n \"select_kit.delete_item\" name=this.itemName}} data-value={{this.itemValue}} data-name={{this.itemName}} type=\"button\" id=\"{{this.id}}-choice\" class=\"btn btn-default selected-choice {{this.extraClass}}\">\n        {{icon \"xmark\"}}\n        {{#if (has-block)}}\n          {{yield}}\n        {{else}}\n          <span class=\"d-button-label\">\n            {{this.itemName}}\n          </span>\n        {{/if}}\n      </button>\n    {{/if}}\n  ", {
      strictMode: true,
      scope: () => ({
        i18n,
        on,
        fn,
        icon
      })
    }), this);
  }
}, [selectKitPropUtils, tagName("")]);
export default SelectedChoice;